import Router from "next/router";

import mem from "mem";
import axios from "axios";

import { clearAllCookies } from "./logout";

const refreshToken = async () => {
    return new Promise(async (resolve, reject) => {
        const baseUrl = process.env.NEXT_PUBLIC_BACKEND_PATH;
        const refreshAxios = axios.create({
            withCredentials: true,
        });

        try {
            if (localStorage.getItem("is_federated") != null) {
                refreshAxios
                    .get(baseUrl + `/api/users/federated_refresh`, {
                        params: {
                            use_new_client_id: true,
                        },
                        headers: {
                            "Content-Type": "application/json",
                        },
                        withCredentials: true,
                    })
                    .then((response) => {
                        resolve(true);
                    })
                    .catch((e) => {
                        console.log(e);
                        clearAllCookies();
                        localStorage.clear();
                        reject(e);
                        Router.push("/");
                    });
            } else {
                refreshAxios
                    .get(baseUrl + `/api/users/refresh_cookie`, {
                        headers: {
                            "Content-Type": "application/json",
                        },
                        withCredentials: true,
                    })
                    .then((resp) => {
                        // console.log(resp);
                        resolve(true);
                    })
                    .catch((e) => {
                        console.log(e);
                        clearAllCookies();
                        localStorage.clear();
                        reject(e);
                        Router.push("/");
                    });
            }
        } catch (e) {
            console.log(e);
            clearAllCookies();
            localStorage.clear();
            reject(e);
            Router.push("/");
        }
    });
};

const maxAge = 6000;

export const memoizedRefreshToken = mem(refreshToken, {
    maxAge,
});
